import React from "react";
import { Container } from "react-bootstrap";
import FreeCourseItem from "../FreeCourseItem/FreeCourseItem";
import "./FreeCourse.css";
import { BsShopWindow } from "react-icons/bs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useState } from "react";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { Link } from "react-router-dom";
export default function FreeCourse() {
    const [freeCourseList, setFreeCourseList] = useState([]);
    useEffect(() => {
        axiosConfig.get("api/courses?page=1&pageSize=8&price=0").then((res) => {
            setFreeCourseList(res.data.data);
        });
    }, []);
    return (
        <>
            <div className="background-free-course">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0  0 1000 100"
                    preserveAspectRatio="none"
                    style={{}}
                >
                    <path
                        className="elementor-shape-fill"
                        d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"
                    ></path>
                </svg>
            </div>
            <div className="free-course-section">
                <Container>
                    <div className="free-course-title">
                        <div className="free-course-title-icon">
                            <BsShopWindow />
                        </div>
                        دوره های رایگان
                    </div>
                    <div className="free-course-slider">
                        <Swiper
                            slidesPerView={2}
                            spaceBetween={10}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                300: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 40,
                                },
                            }}
                            modules={[Autoplay]}
                            className="mySwiper"
                        >
                            {freeCourseList?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <Link to={"/course/" + item.title}>
                                        <FreeCourseItem item={item} />
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </Container>
            </div>
            <div className="background-bottom-free-course">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0  0 1000 100"
                    preserveAspectRatio="none"
                    style={{}}
                >
                    <path
                        className="elementor-shape-fill"
                        d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"
                    ></path>
                </svg>
            </div>
        </>
    );
}
